// todo - somehow consolidate these functions with FiltersMixin.js
export default {
  methods: {
    hashParts() {
      let hash = window.location.hash.substring(1);
      if (!hash) return null;
      let pieces = hash.split("&");
      let data = {},
        parts;
      // process each query pair
      for (let i = 0; i < pieces.length; i++) {
        parts = pieces[i].split("=");
        if (parts.length < 2) {
          parts.push("");
        }
        data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
      }
      return data;
    },
    hashValForKey(key) {
      let hashParts = this.hashParts();
      if (!hashParts) return null;
      if (!hashParts[key]) return null;
      return hashParts[key];
    },
    hashHasAdd() {
      let rtn = false;
      if (this.hashValForKey("add")) rtn = true;
      if (this.hashValForKey("addOD")) rtn = true;
      if (this.hashValForKey("addOS")) rtn = true;
      return rtn;
    },
    removeFromHash(key) {
      let hashParts = this.hashParts();
      if (!hashParts) return;
      delete hashParts[key];
      let keys = Object.keys(hashParts);
      let arr = [];
      keys.forEach((key) => {
        arr.push(`${key}=${hashParts[key]}`);
      });
      let str = arr.join("&");
      this.updateHashWithParamString(str);
    },

    updateHashWithParamString(hash) {
      hash = "#" + hash;
      if (history.pushState) {
        history.pushState(null, null, hash);
      } else {
        location.hash = hash;
      }
    },
  },
};
